import { MapPinIcon } from "@heroicons/react/24/solid";
import Label from "components/Label/Label";
import { FC, useEffect, useState } from "react";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import Input from "shared/Input/Input";
import Select from "shared/Select/Select";
import CommonLayout from "./CommonLayout";
import FormItem from "./FormItem";
import { Map, Marker } from "@vis.gl/react-google-maps";
import { COUNTRIES } from "data/countries";
import { useLocation, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import api from "../../api";
import { useAppSelector, useAppDispatch } from "../../redux/hook";
import { updateFormData, clearFormData, selectFormData } from "../../redux/reducers/formReducer";

export interface PageAddListing2Props {}

const PageAddListing2: FC<PageAddListing2Props> = () => {
  const formData = useAppSelector(selectFormData);
  const dispatch = useAppDispatch();
  
  const {state} = useLocation();
  const location = useLocation();
  const navigate = useNavigate();
  const companyType = location.pathname.indexOf('brand')>-1 ? 'brand' : 'agency';
  const { user } = useAppSelector(state => (state as any).user);

  let input = state?.input || {};
  
  const { register, handleSubmit, formState: { errors }, setValue } = useForm({
    defaultValues: {
      street_address: formData.street_address || '',
      city: formData.city || '',
      post: formData.post || ''
    }
  });

  const [inputValues, setInputValues] = useState({
    ...input,
    country: formData.country || input.country || 'DE',
  });

  useEffect(() => {
    if (formData.street_address) setValue('street_address', formData.street_address);
    if (formData.city) setValue('city', formData.city);
    if (formData.post) setValue('post', formData.post);
    if (formData.country) {
      setInputValues(prev => ({
        ...prev,
        country: formData.country
      }));
    }
  }, []); 

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInputValues((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    dispatch(updateFormData({ [name]: value }));
  };

  const handleOnSubmit = (data) => {
    const finalData = {
      ...inputValues,
      user_id: user.id,
      street_address: data.street_address,
      city: data.city,
      post: data.post
    };
  
    dispatch(updateFormData(finalData));
    
    // push submit
    api.registerCompany(finalData, () => {
      dispatch(clearFormData());
      navigate('/register/thank-you');
    });
  }

  return (
    <CommonLayout
      index="02"
      nextHref={`/thank-you`}
      backtHref={`/register/${companyType}`}
      nextBtnText="Save"
      onSubmit={handleSubmit(handleOnSubmit)}
    >
      <>
        <h2 className="text-2xl font-semibold">Office Address</h2>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
        {/* FORM */}
        <div className="space-y-8">
          {/* ITEM */}
          <FormItem label="Country">
            <Select
              name='country'
              value={inputValues?.country}
              onChange={handleInputChange}
            >
              <option value="DE">Germany</option>
              {
                COUNTRIES.map((c) => (
                  <option key={c.code} value={c.code}>{c.name}</option>
                ))
              }
            </Select>
          </FormItem>
          <FormItem label="Street">
            <Input 
              placeholder="..."
              name='street_address'
              {...register( "street_address", {required: 'Street field is required.'} )}
              onChange={(e) => {
                register("street_address").onChange(e);
                dispatch(updateFormData({ street_address: e.target.value }));
              }}
            />
            {errors.street_address && 
              <span className="ml-1 mt-2 text-xs text-red-500">
                {errors.street_address.message?.toString()}
              </span>
            }
          </FormItem>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-5">
            <FormItem label="City">
              <Input
                name='city'
                {...register( "city", {required: 'City field is required.'} )}
                onChange={(e) => {
                  register("city").onChange(e);
                  dispatch(updateFormData({ city: e.target.value }));
                }}
              />
              {errors.city && 
                <span className="ml-1 mt-2 text-xs text-red-500">
                  {errors.city.message?.toString()}
                </span>
              }
            </FormItem>
            <FormItem label="Post">
              <Input 
                name='post'
                {...register( "post", {required: 'Post field is required.'} )}
                onChange={(e) => {
                  register("post").onChange(e);
                  dispatch(updateFormData({ post: e.target.value }));
                }}
              />
              {errors.post && 
                <span className="ml-1 mt-2 text-xs text-red-500">
                  {errors.post.message?.toString()}
                </span>
              }
            </FormItem>
          </div>
        </div>
      </>
    </CommonLayout>
  );
};

export default PageAddListing2;
